// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useContext} from 'react';
import cn from 'classnames';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import Icon_close from '../../img/icons/24/close.svg';
import Icon_check from '../../img/icons/24/check_line.svg';
import Icon_subtract from '../../img/icons/24/subtract.svg';
import Icon_oculus from '../../img/logo_full.svg';
import Icon_webshare from '../../img/homepage/webshare.svg';
import Icon_luna from '../../img/homepage/luna.svg';
import Icon_smartproxy from '../../img/homepage/smartproxy.svg';
import Icon_soax from '../../img/homepage/soax.svg';
import Icon_iproyal from '../../img/homepage/iproyal.svg';
import {Button} from '../../lib/button';
import styles from './proxies_compare.module.less';
import {use_app_context} from '../../../../toolip/pub/lib/app_context';

interface t_data {
    provider: string;
    icon: JSX.Element;
    isp_unlim: string;
    dc_dedicated_unlim: string;
    dc_shared_unlim: string;
    ethic_ips: string;
    socks5: string;
    countries_150: string;
    ips_300: string;
    ips_dedicated: string;
    flat_rate_prices: string;
    pricing: string;
    btn?: JSX.Element
}

type t_optional = 'icon' | 'btn' | 'provider';
interface i_col_props {
    data: Omit<t_data, t_optional> & Partial<Pick<t_data, t_optional>>;
}

const comparison_data=(show_promo: boolean):t_data[]=>[
    {
        provider: 'oculus',
        icon: <Icon_oculus width={160} height={32}/>,
        isp_unlim: 'yes',
        dc_dedicated_unlim: 'yes',
        dc_shared_unlim: 'yes',
        ethic_ips: 'yes',
        socks5: 'yes',
        countries_150: 'yes',
        ips_300: 'yes',
        ips_dedicated: 'yes',
        flat_rate_prices: 'yes',
        pricing: '$2.2/IP',
        btn: <Button caption={ show_promo ? 'Try now for free': 'Try now'}
          size={'s'} to={'/pricing'}/>,
    },
    {
        provider: 'webshare',
        icon: <Icon_webshare />,
        isp_unlim: 'disabled',
        dc_dedicated_unlim: 'disabled',
        dc_shared_unlim: 'disabled',
        ethic_ips: 'yes',
        socks5: 'yes',
        countries_150: 'yes',
        ips_300: 'disabled',
        ips_dedicated: 'yes',
        flat_rate_prices: 'no',
        pricing: '$2.99/IP',
    },
    {
        provider: 'iproyal',
        icon: <Icon_iproyal />,
        isp_unlim: 'yes',
        dc_dedicated_unlim: 'yes',
        dc_shared_unlim: 'disabled',
        ethic_ips: 'yes',
        socks5: 'yes',
        countries_150: 'yes',
        ips_300: 'no',
        ips_dedicated: 'yes',
        flat_rate_prices: 'no',
        pricing: '$1.39/IP',
    },
    {
        provider: 'soax',
        icon: <Icon_soax />,
        isp_unlim: 'disabled',
        dc_dedicated_unlim: 'disabled',
        dc_shared_unlim: 'disabled',
        ethic_ips: 'yes',
        socks5: 'yes',
        countries_150: 'disabled',
        ips_300: 'yes',
        ips_dedicated: 'disabled',
        flat_rate_prices: 'no',
        pricing: '$0.5/GB',
    },
    {
        provider: 'smartproxy',
        icon: <Icon_smartproxy />,
        isp_unlim: 'yes',
        dc_dedicated_unlim: 'yes',
        dc_shared_unlim: 'yes',
        ethic_ips: 'yes',
        socks5: 'yes',
        countries_150: 'disabled',
        ips_300: 'yes',
        ips_dedicated: 'yes',
        flat_rate_prices: 'no',
        pricing: '$1.6/IP',
    },
    {
        provider: 'luna',
        icon: <Icon_luna />,
        isp_unlim: 'yes',
        dc_dedicated_unlim: 'disabled',
        dc_shared_unlim: 'disabled',
        ethic_ips: 'yes',
        socks5: 'yes',
        countries_150: 'disabled',
        ips_300: 'no',
        ips_dedicated: 'yes',
        flat_rate_prices: 'yes',
        pricing: '$2.4/IP',
    },
];

const feature_titles = {
    isp_unlim: 'Unlimited Traffic (ISP)',
    dc_dedicated_unlim: 'Unlimited Traffic DC (Dedicated)',
    dc_shared_unlim: 'Unlimited Traffic DC (Shared)',
    ethic_ips: 'Ethically Sourced IPs',
    socks5: 'SOCKS5 Support',
    countries_150: 'IPs from over 150 countries',
    ips_300: 'Over 300k IPs',
    ips_dedicated: 'Dedicated IPs',
    flat_rate_prices: 'Flat rate prices',
    pricing: 'Pricing Starting from'
};

const Col = (props: i_col_props)=>{
    const {data} = props;
    const {theme} = useContext(Settings_context);
    const col_cls = cn(styles.col,
        data.provider=='oculus' && styles.oculus,
        !data.provider && styles.titles,
    );
    return <div className={col_cls}>
      <div className={styles.col_header}>{data.icon}</div>
      {Object.keys(feature_titles).map(k=>{
        const v = data[k];
        const cell_cls = cn(styles.col_cell, styles[k],
            data.provider && styles[v]);
        const p_cls = data.provider=='oculus' ? cn(theme.p16, theme.semi)
            : cn(theme.p14, data.provider && theme.med);
        return <div key={k} className={cell_cls}>
          {v=='yes' ? <Icon_check/>
          : v=='no' ? <Icon_subtract/>
          : v=='disabled' ? <Icon_close/> : <p className={p_cls}>{v}</p>}
        </div>;
      })}
      <div className={styles.col_footer}>{data.btn}</div>
    </div>;
};

export const Proxies_compare = ()=>{
    const {show_free_zone_promo} = use_app_context();
    return <section className={styles.proxies_compare}>
        <div className={styles.bg}/>
        <h2>Why choose Oculus Proxies?</h2>
        <div className={styles.table_wrapper}>
          <div className={styles.table}>
            <Col data={feature_titles}/>
            {comparison_data(show_free_zone_promo).map(item=>{
              return <Col key={item.provider} data={item}/>;
            })}
          </div>
        </div>
    </section>;
};
